"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const antd_1 = require("antd");
const PaymentFormStyle_1 = require("../paymentForm/PaymentFormStyle");
const constants_1 = require("../../assets/constants/constants");
const validations_1 = require("../../utils/validations");
const PixView = ({ needPaymentDocCPF, needDebitPhoneBR, selectedPaymentType }) => {
    return (react_1.default.createElement(antd_1.Row, { id: "Pix" },
        needPaymentDocCPF && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(antd_1.Col, { xs: { span: 24, flex: '1' }, sm: { span: 24, flex: '1' }, lg: { span: 8 } },
                react_1.default.createElement(PaymentFormStyle_1.FormItemFormulary, { labelCol: { span: 24 }, name: "paymentDocCPF", label: "CPF", rules: [
                        { required: selectedPaymentType === constants_1.PAYMENT_TYPE.PIX },
                        () => ({
                            validator(rule, value) {
                                if (!value) {
                                    return Promise.resolve();
                                }
                                if (!(0, validations_1.validateCPF)(value)) {
                                    return Promise.reject(new Error('Insira um CPF válido'));
                                }
                                return Promise.resolve();
                            },
                        }),
                    ] },
                    react_1.default.createElement(PaymentFormStyle_1.MaskInputStyled, { mask: "111.111.111-11", placeholder: "XXX.XXX.XXX-XX" }))),
            react_1.default.createElement(antd_1.Col, { xs: { span: 0 }, sm: { span: 0 }, lg: { span: 2 } }))),
        needDebitPhoneBR && (react_1.default.createElement(antd_1.Col, { xs: { span: 24, flex: '1' }, sm: { span: 24, flex: '1' }, lg: { span: 8 } },
            react_1.default.createElement(PaymentFormStyle_1.FormItemFormulary, { labelCol: { span: 24 }, name: "phoneBR", label: "Telefone", rules: [
                    { required: selectedPaymentType === constants_1.PAYMENT_TYPE.DEBIT },
                    () => ({
                        validator(rule, value) {
                            if (!value) {
                                return Promise.resolve();
                            }
                            if (value.replace(/\D/g, '').length < 10 || value.replace(/\D/g, '').length > 11) {
                                return Promise.reject(new Error('Insira um número válido'));
                            }
                            return Promise.resolve();
                        },
                    }),
                ] },
                react_1.default.createElement(PaymentFormStyle_1.MaskInputStyled, { mask: "(11) 11111-1111", placeholder: "(XX) XXXXX-XXXX" })))),
        react_1.default.createElement(antd_1.Col, { span: 24 },
            react_1.default.createElement(antd_1.Typography.Paragraph, null, "Pagar com Pix"),
            react_1.default.createElement(antd_1.Typography.Text, null, "Pague com Pix em qualquer dia e a qualquer hora! O pagamento \u00E9 instant\u00E2neo, pr\u00E1tico e pode ser feito em poucos segundos. \u00C9 muito r\u00E1pido e seguro :)"),
            react_1.default.createElement("br", null),
            react_1.default.createElement(antd_1.Typography.Text, null, "Ao clicar em Finalizar Reserva, voc\u00EA ser\u00E1 redirecionado a um ambiente seguro para pagamento com PIX, selecione a op\u00E7\u00E3o PIX e siga as instru\u00E7\u00F5es informadas na tela."),
            react_1.default.createElement(PaymentFormStyle_1.RowPix, null,
                react_1.default.createElement(antd_1.Col, { span: 21 },
                    react_1.default.createElement(antd_1.Typography.Paragraph, null, "Abra o app do seu banco ou institui\u00E7\u00E3o financeira e entre no ambiente Pix."),
                    react_1.default.createElement(antd_1.Typography.Paragraph, null, "Escolha a op\u00E7\u00E3o Pagar com QR Code e escaneie o c\u00F3digo que ir\u00E1 aparecer na tela."),
                    react_1.default.createElement(antd_1.Typography.Paragraph, null, "Caso esteja finalizando a reserva pelo seu smartphone, ao ser redirecionado para a p\u00E1gina de pagamento, copie o c\u00F3digo de pagamento e cole no seu aplicativo de pagamentos."),
                    react_1.default.createElement(antd_1.Typography.Paragraph, null, "Confirme as informa\u00E7\u00F5es e finalize a compra."))))));
};
exports.default = PixView;
